import { ActiveStateStrategy, NavigationItemBase } from "@/domains/navigation/navigation-item"

import type { Location } from "../navigation-item"

export class ActiveStateStartsWithFilteredStrategy implements ActiveStateStrategy {
  private startsWith: string
  private filters: string[]

  constructor(startsWith: string, filters: string[]) {
    this.startsWith = startsWith
    this.filters = filters
  }

  isActive(location: Location, item: NavigationItemBase): boolean {
    // if the filters math then this return false
    if (this.filters.some((filter) => location.pathname.includes(filter))) {
      return false
    }

    return location.pathname.startsWith(this.startsWith)
  }
}
